// extracted by mini-css-extract-plugin
module.exports = {"w6wwq2r":"w6wwq2r"};